var _path, _path2, _line, _line2, _line3, _rect, _rect2, _line4, _line5, _line6, _line7, _line8, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBillingInfoLarge = function SvgBillingInfoLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51711 3.62043C6.51711 2.42064 7.48973 1.44801 8.68952 1.44801H30.8699L35.4826 5.40176V38.379C35.4826 39.5788 34.51 40.5515 33.3102 40.5515H8.68952C7.48973 40.5515 6.51711 39.5788 6.51711 38.379V3.62043Z",
    stroke: "black",
    strokeWidth: 1.44828
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4135 1.44824L30.4135 5.79307L35.4824 5.79307",
    stroke: "black",
    strokeWidth: 1.44828
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.8628,
    y1: 11.5862,
    x2: 24.6214,
    y2: 11.5862,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.8628,
    y1: 14.4829,
    x2: 19.5525,
    y2: 14.4829,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10.8628,
    y1: 34.7585,
    x2: 19.5525,
    y2: 34.7585,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8628,
    y: 17.3797,
    width: 20.2759,
    height: 5.7931,
    rx: 0.724138,
    stroke: "black",
    strokeWidth: 1.44828
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8628,
    y: 23.1724,
    width: 20.2759,
    height: 5.7931,
    rx: 0.724138,
    stroke: "black",
    strokeWidth: 1.44828
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13.7593,
    y1: 26.0688,
    x2: 19.5524,
    y2: 26.0688,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 26.7925,
    y1: 26.0688,
    x2: 28.2408,
    y2: 26.0688,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 13.7593,
    y1: 20.2759,
    x2: 19.5524,
    y2: 20.2759,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 26.7925,
    y1: 20.2759,
    x2: 28.2408,
    y2: 20.2759,
    stroke: "black",
    strokeWidth: 1.44828,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 23.896,
    y1: 17.3794,
    x2: 23.896,
    y2: 28.9656,
    stroke: "black",
    strokeWidth: 1.44828
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1551,
    cy: 34.3966,
    r: 2.53448,
    stroke: "black",
    strokeWidth: 1.44828
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4102 5.43117V7.96565H11.0293V5.43117H10.4102Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6771 5.43117V6.85048L11.932 5.30444V7.96565H12.5185V6.54634L14.2709 8.09237V5.43117H13.6771Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2296 6.94099L15.6105 5.43117H14.8936L16.2296 8.12496L17.5584 5.43117H16.8415L16.2296 6.94099Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6363 6.69841C18.6363 6.58496 18.6532 6.48237 18.687 6.39065C18.7208 6.29893 18.7691 6.21927 18.8318 6.15168C18.897 6.0841 18.973 6.03099 19.0599 5.99237C19.1492 5.95375 19.2482 5.93444 19.3568 5.93444C19.4654 5.93444 19.5632 5.95375 19.6501 5.99237C19.7394 6.03099 19.8154 6.0841 19.8782 6.15168C19.941 6.21927 19.988 6.30013 20.0194 6.39427C20.0508 6.486 20.0665 6.58737 20.0665 6.69841C20.0665 6.80944 20.0496 6.91203 20.0158 7.00617C19.982 7.09789 19.9337 7.17755 19.871 7.24513C19.8082 7.31272 19.7334 7.36582 19.6465 7.40444C19.5596 7.44306 19.463 7.46237 19.3568 7.46237C19.2482 7.46237 19.1492 7.44306 19.0599 7.40444C18.973 7.36582 18.897 7.31272 18.8318 7.24513C18.7691 7.17755 18.7208 7.09668 18.687 7.00255C18.6532 6.90841 18.6363 6.80703 18.6363 6.69841ZM17.9918 6.69841C17.9918 6.89393 18.0244 7.07375 18.0896 7.23789C18.1548 7.40203 18.2489 7.54444 18.372 7.66513C18.4951 7.78582 18.6399 7.87996 18.8065 7.94755C18.973 8.01272 19.1565 8.04531 19.3568 8.04531C19.5548 8.04531 19.7358 8.01272 19.8999 7.94755C20.0665 7.87996 20.2113 7.78582 20.3344 7.66513C20.4575 7.54444 20.5529 7.40203 20.6204 7.23789C20.688 7.07375 20.7218 6.89393 20.7218 6.69841C20.7218 6.50289 20.6868 6.32427 20.6168 6.16255C20.5468 5.99841 20.4503 5.8572 20.3272 5.73893C20.2065 5.62065 20.0629 5.53013 19.8963 5.46737C19.7322 5.40462 19.5523 5.37324 19.3568 5.37324C19.1613 5.37324 18.9803 5.40462 18.8137 5.46737C18.6472 5.53013 18.5023 5.62065 18.3792 5.73893C18.2561 5.8572 18.1608 5.99841 18.0932 6.16255C18.0256 6.32427 17.9918 6.50289 17.9918 6.69841Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4724 5.43117V7.96565H22.0915V5.43117H21.4724Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 6.69841C23.5156 6.58255 23.5349 6.47996 23.5735 6.39065C23.6145 6.29893 23.67 6.22048 23.74 6.15531C23.81 6.09013 23.8909 6.04065 23.9826 6.00686C24.0743 5.97306 24.1721 5.95617 24.2759 5.95617C24.3966 5.95617 24.5028 5.97186 24.5945 6.00324C24.6862 6.03462 24.7671 6.07565 24.8371 6.12634C24.9095 6.17703 24.9735 6.23255 25.029 6.29289V5.62668C24.9276 5.54703 24.8166 5.48548 24.6959 5.44203C24.5776 5.39617 24.4256 5.37324 24.2397 5.37324C24.0345 5.37324 23.8474 5.40582 23.6785 5.471C23.5095 5.53375 23.3623 5.62306 23.2368 5.73893C23.1112 5.85479 23.0147 5.99479 22.9471 6.15893C22.8819 6.32065 22.8493 6.50048 22.8493 6.69841C22.8493 6.89634 22.8819 7.07737 22.9471 7.24151C23.0147 7.40324 23.1112 7.54203 23.2368 7.65789C23.3623 7.77134 23.5095 7.86065 23.6785 7.92582C23.8474 7.98858 24.0345 8.01996 24.2397 8.01996C24.4256 8.01996 24.5776 7.99703 24.6959 7.95117C24.8166 7.90531 24.9276 7.84496 25.029 7.77013V7.10393C24.9735 7.16427 24.9095 7.21979 24.8371 7.27048C24.7671 7.32117 24.6862 7.3622 24.5945 7.39358C24.5028 7.42496 24.3966 7.44065 24.2759 7.44065C24.1721 7.44065 24.0743 7.42375 23.9826 7.38996C23.8909 7.35617 23.81 7.30668 23.74 7.24151C23.67 7.17634 23.6145 7.0991 23.5735 7.00979C23.5349 6.91806 23.5156 6.81427 23.5156 6.69841Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2933 7.96565H27.5714V7.46237H26.2933V7.96565ZM26.2933 5.93444H27.5714V5.43117H26.2933V5.93444ZM26.2933 6.88306H27.499V6.38341H26.2933V6.88306ZM25.8914 5.43117V7.96565H26.478V5.43117H25.8914Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBillingInfoLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billing-info-large.1c7ae23e.svg";
export { ForwardRef as ReactComponent };